export default "assets/images/icons/car-b844bc22.svg";